<template>
  <section class="app-solicitacao">
    <v-container grid-list-xl>
      <v-layout row wrap>
        <v-flex lg12 sm12 xs12>
          <v-card outlined class="app-card">
            <v-card-title class="app-card-title"
              >Abrir Solicitação/Reclamação</v-card-title
            >
            <v-card-text class="app-card-content">
              <div v-if="!sendedSolicitation && !codigoSolicitation">
                <v-stepper dense class="elevation-0 app-stepper">
                  <v-stepper-header class="elevation-0 app-card-stepper-header">
                    <v-stepper-step step="1" :complete="stepperOneValid"
                      >Solicitante</v-stepper-step
                    >
                    <v-stepper-step step="2" :complete="stepperTwoValid"
                      >Tipo de Solicitação</v-stepper-step
                    >
                    <v-stepper-step step="3" :complete="stepperThreeValid"
                      >Solicitação</v-stepper-step
                    >
                  </v-stepper-header>
                  <v-stepper-content
                    :key="'1-content'"
                    :step="1"
                    :style="
                      currentStep === 1 ? 'display: block;' : 'display: none;'
                    "
                  >
                    <FirstStep />
                  </v-stepper-content>
                  <v-stepper-content
                    :key="'2-content'"
                    :step="2"
                    :style="
                      currentStep === 2 ? 'display: block;' : 'display: none;'
                    "
                  >
                    <SecondStep />
                  </v-stepper-content>
                  <v-stepper-content
                    :key="'3-content'"
                    :step="3"
                    :style="
                      currentStep === 3 ? 'display: block;' : 'display: none;'
                    "
                  >
                    <ThirdStep />
                  </v-stepper-content>
                </v-stepper>
                <div class="loading" v-if="isLoading">
                  <v-progress-circular
                    :size="25"
                    color="primary"
                    indeterminate
                  ></v-progress-circular>
                </div>
              </div>
              <div class="success-send" v-else>
                <v-icon :size="100" color="green">check_circle_outline</v-icon>
                <h3>Recebemos sua solicitação, Obrigado!</h3>
                <h4>Número da solicitação</h4>
                <h1>{{ codigoSolicitation }}</h1>
                <v-btn depressed color="primary" @click.prevent.stop="reset()"
                  >Nova Solicitação</v-btn
                >
              </div>
            </v-card-text>
          </v-card>
        </v-flex>
      </v-layout>
    </v-container>
  </section>
</template>

<script>
import FirstStep from "@/components/ouvidoria/FirstStep";
import SecondStep from "@/components/ouvidoria/SecondStep";
import ThirdStep from "@/components/ouvidoria/ThirdStep";
import SolicitacaoModule from "@/store/modules/solicitacao";
import SolicitacaoService from "@/services/solicitacao.service";

export default {
  metaInfo: {
    title: "Solicitação - Central de Serviços"
  },
  components: {
    FirstStep,
    SecondStep,
    ThirdStep
  },
  data() {
    return {};
  },
  methods: {
    reset() {
      SolicitacaoModule.reset();
    }
  },
  destroyed() {
    this.reset();
  },
  computed: {
    solicitacao: {
      get: () => SolicitacaoModule.solicitacao
    },
    isLoading: {
      get: () => SolicitacaoModule.isLoading
    },
    sendedSolicitation: {
      get: () => SolicitacaoModule.sendedSolicitation
    },
    codigoSolicitation: {
      get: () => SolicitacaoModule.codigoSolicitation
    },
    stepperOneValid: {
      get: () => SolicitacaoModule.stepperOneValid
    },
    stepperTwoValid: {
      get: () => SolicitacaoModule.stepperTwoValid
    },
    stepperThreeValid: {
      get: () => SolicitacaoModule.stepperThreeValid
    },
    currentStep: {
      get: () => SolicitacaoModule.currentStep
    }
  }
};
</script>

<style lang="scss" scoped>
.app {
  &-card {
    &-title {
      margin-bottom: 0px !important;
    }
    &-content {
      padding: 0px !important;
      .loading {
        position: absolute;
        top: 0;
        width: 100%;
        height: 100%;
        background: rgba(255, 255, 255, 0.8);
        display: flex;
        align-items: center;
        text-align: center;
        .v-progress-circular {
          margin: auto;
        }
      }
      .success-send {
        padding: 40px;
        text-align: center;
        h3 {
          font-weight: 400 !important;
        }
        h1 {
          font-weight: 900 !important;
          margin: 0px 0px 25px 0px;
        }
      }
    }
    &-stepper {
      &-header {
        border-bottom: solid 1px #e6e6e6 !important;
      }
    }
  }
}

@media screen and (max-width: 480px) {
  .v-stepper__step {
    font-size: 11px;
    padding: 10px !important;
  }
  .v-stepper__content {
    padding: 0px;
  }
}
</style>
